export default "mutation requestTrial($email: String!) {\n\trequestTrial: requestTrialV2(email: $email) {\n\t\ttrialId\n\t}\n}";